<template>
    <div class="login-container">
      <div class="login-border">
        <div class="login-card">
          <img
            src="./megafest.png"
            alt="Logo MegaFest"
            class="login-logo"
          >
  
          <h1 class="login-title">
            Inicio de Sesión
          </h1>
  
          <form @submit.prevent="handleLogin">
            <div class="form-group">
              <label for="email">Correo Electrónico</label>
              <input
                id="email"
                v-model="userEmail"
                type="email"
                placeholder="Ingresa tu correo"
                required
              >
            </div>
  
            <div class="form-group">
              <label for="password">Contraseña</label>
              <input
                id="password"
                v-model="userPassword"
                type="password"
                placeholder="Ingresa tu contraseña"
                required
              >
              <p v-if="errorMessagelogin" class="error-message">{{ errorMessagelogin }}</p>
            </div>
  
            <button
              type="submit"
              class="login-button"
              :disabled="loading"
            >
              <span v-if="loading">Cargando...</span>
              <span v-else>Iniciar Sesión</span>
            </button>
          </form>
  
          <p class="login-footer">
            OASYSBEN
          </p>
        </div>
      </div>
  
      <!-- Diálogo para cambio de contraseña -->
      <div v-if="dialog" class="password-dialog">
        <div class="dialog-content">
          <h2>Cambiar Contraseña</h2>
          <form @submit.prevent="changePassword">
            <div class="form-group">
              <label>Contraseña Actual</label>
              <input
                v-model="currentPassword"
                type="password"
                required
              >
            </div>
            <div class="form-group">
              <label>Nueva Contraseña</label>
              <input
                v-model="newPassword"
                type="password"
                required
              >
            </div>
            <div class="form-group">
              <label>Confirmar Nueva Contraseña</label>
              <input
                v-model="confirmPassword"
                type="password"
                required
              >
            </div>
            <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
            <div class="dialog-buttons">
              <button type="submit">Cambiar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent } from 'vue';
  import { useRouter } from 'vue-router';
  import LoginService from "@/services/Login";
  import Usuarios from "@/services/UsuarioService";
  import '@/assets/css/login.css';
  //import imglogo from '@/assets/megafest.png';
  
  export default defineComponent({
    name: 'LoginPage',
  
    setup() {
      const router = useRouter();
      return { router };
    },
  
    data() {
      return {
        loading: false,
        dialog: false,
        LoginServices: new LoginService(),
        userEmail: '',
        userPassword: '',
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        currentUsuario: {
          name: '',
          email: '',
          password: '',
          password_confirmation: '',
          nombre_completo: '',
          carnet: '',
        },
        errorMessage: '',
        errorMessagelogin: '',
        id: null
      };
    },
  
    methods: {
      async handleLogin() {
        this.loading = true;
        this.errorMessagelogin = '';
        
        try {
          const response = await this.LoginServices.loginUser(this.userEmail, this.userPassword);
          
          if (response === false) {
            this.errorMessagelogin = 'Usuario y/o contraseña Incorrecta.';
            return;
          }
          
          if (response) {
            await this.cambiar_primera_contra();
            await this.ver_datos_user();
          }
        } catch (error) {
          console.error('Error al iniciar sesión:', error);
          this.errorMessagelogin = 'Ocurrió un error al iniciar sesión.';
        } finally {
          this.loading = false;
        }
      },
  
      async ver_datos_user() {
        try {
          const first_pass_user = new Usuarios();
          const response = await first_pass_user.getDatosUserLogued();
          
          if (response) {
            this.id = response.id;
            this.currentUsuario = {
              name: response.name,
              email: response.email,
              nombre_completo: response.nombre_completo,
              carnet: response.carnet,
            };
          }
        } catch (error) {
          console.error('Error obteniendo datos del usuario:', error);
        }
      },
  
      async cambiar_primera_contra() {
        try {
          const contra_primera = new LoginService();
          const response = await contra_primera.primer_pass();
          
          if (response === false) {
            this.dialog = true;
          } else {
            this.router.push('/mesas');
          }
        } catch (error) {
          console.error('Error verificando primera contraseña:', error);
        }
      },
  
      async changePassword() {
        this.errorMessage = '';
        this.loading = true;
  
        try {
          // Validaciones
          if (!this.currentPassword || !this.newPassword || !this.confirmPassword) {
            this.errorMessage = 'Todos los campos son requeridos.';
            return;
          }
  
          if (this.newPassword !== this.confirmPassword) {
            this.errorMessage = 'La nueva contraseña y su confirmación no coinciden.';
            return;
          }
  
          const currentUser = new Usuarios();
          const isCurrentPasswordValid = await currentUser.validateCurrentPassword(this.currentPassword);
  
          if (!isCurrentPasswordValid) {
            this.errorMessage = 'La contraseña actual es incorrecta.';
            return;
          }
  
          const updatedUser = {
            current_password: this.currentPassword,
            new_password: this.newPassword,
            new_password_confirmation: this.confirmPassword,
          };
  
          const first_pass_user = new Usuarios();
          const response = await first_pass_user.updateUsuariosFirstPass(this.id, updatedUser);
  
          if (response === false) {
            this.errorMessage = 'Error en el cambio del primer pass.';
          } else {
            this.dialog = false;
            this.router.push('/dashboard');
          }
        } catch (error) {
          console.error('Error cambiando contraseña:', error);
          this.errorMessage = 'Ocurrió un error al cambiar la contraseña.';
        } finally {
          this.loading = false;
        }
      }
    }
  });
  </script>
  
  <style scoped>
  .error-message {
    color: red;
    margin-top: 5px;
  }
  
  .password-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .dialog-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    max-width: 90%;
  }
  
  .dialog-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  
  button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  </style>